import { FlokiAction } from '@cosmobile/ng-floki-types'
import { Injectable } from '@angular/core'
import { ActionHandler } from '@cosmobile/ng-floki-types/lib/interfaces/action-handler.interface'
import { Type } from '@cosmobile/floki-base'
import { ActivatedRoute } from '@angular/router'
import { PublishService } from '../services/publish.service'
import { FlokiI18nService } from '@cosmobile/ng-floki-i18n'
import { Language } from '@cosmobile/ng-floki-i18n'
import { SerieService } from '../services/serie.service';



@FlokiAction('serie-duplicate')
@Injectable()
export class SerieDuplicateAction implements ActionHandler {
  icon = {
    name: 'copy',
    color: 'black',
  }
  name = 'SERIE_DUPLICATE'

  constructor(
    public service: SerieService,
  ) {}

  isVisible(type: Type, related: any, currentRoute: ActivatedRoute) {
    let visible = false
    if (related && related.attributeSet.name && 'Serie' === related.attributeSet.name) {
      visible = true
    }
    return visible
  }

  async handle(type: Type, related: any, currentRoute: ActivatedRoute) {
    await this.service.duplicate(related)
    location.reload()
  }
}
